module.exports = __webpack_public_path__ + "static/img/sm_js_2.e244169.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sm/sm_js_2.png
// module id = HyVV
// module chunks = 1